import { render, staticRenderFns } from "./DeclarationISS.vue?vue&type=template&id=3ae30678"
import script from "./DeclarationISS.vue?vue&type=script&lang=js"
export * from "./DeclarationISS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports